import { render } from "src/website-apps/shared/utils/render";
import { FindRoot } from "./root";

render(<FindRoot />);
